import React, { useCallback, useLayoutEffect, useState } from 'react';

import { currentUserIDState } from '@atom/setting/user';
import { useDocument } from '@nandorojo/swr-firestore';
import { getAllCurrentDocs } from '@store/firebase/user/getAllCurrentDocs';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import { ImainHome } from '@typings/setting/mainHome.interface';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import DocItem from './DocItem';
import { LATEST_INTEGRATE } from '@typings/mainHome/latestIntegrate';
import { LATEST_DOCS_TYPE } from '@typings/mainHome/latestDocs';
import TitleWidgetSec from '@pages/MainHome/components/TitleWidgetSec';
import { MAIN_HOME_SEC_TYPE } from '@typings/setting/MainHomeSecType';
import { mainHomeSettingState } from '@atom/setting/homeSettingState';

export const ScrollSec = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  margin: auto 0;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Item = styled.div`
  /* width: 100%; */
`;

const EmptyPage = styled.div`
  width: 100%;
  color: var(--subTextColor);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;

type Props = {
  noShowDate?: boolean;
  maxHeight?: string;
  mobileMaxHeight?: string;
};
function CurrentDocs({ noShowDate, maxHeight, mobileMaxHeight }: Props) {
  const history = useNavigate();
  const [data, setData] = useState<any>([]);
  const currentUserID = useRecoilValue(currentUserIDState);
  const mainHomeData = useRecoilValue(mainHomeSettingState);

  useLayoutEffect(() => {
    async function getData() {
      const dataSet = await getAllCurrentDocs({
        limit: 20,
        selectedPaths: mainHomeData?.latestIntegrate || [],
      });
      setData(dataSet);
    }
    getData();
  }, [mainHomeData, currentUserID]);

  const handleItemClick = useCallback((collectionPath, id) => {
    history(`/${collectionPath}/${id}`);
  }, []);

  if (data?.length === 0)
    return (
      <EmptyPage>
        <p>최신 글이 없습니다.</p>
      </EmptyPage>
    );

  return (
    <>
      <TitleWidgetSec
        titleDesignType={mainHomeData?.titleDesignType}
        title={mainHomeData?.latestTitle}
        style={{ gridArea: MAIN_HOME_SEC_TYPE.LATEST }}
        maxHeight={maxHeight}
        mobileMaxHeight={mobileMaxHeight}
      >
        {data?.map((item, i) => {
          return (
            <Item
              key={item.id}
              onClick={() => handleItemClick(item.collectionPath, item.id)}
            >
              <DocItem
                data={item}
                icon={mainHomeData?.latestDocsType || LATEST_DOCS_TYPE.STAR}
                noShowDate={noShowDate}
              />
            </Item>
          );
        })}
      </TitleWidgetSec>
    </>
  );
}

export default CurrentDocs;
